import React from 'react'

const ItemMember = (props) => {

    const item = props?.member;

    

    return (
        <div className='card-content is-clearfix'>
            <div className='is-pulled-left'>
                <p className='is-size-5'> {item.name}</p>
            </div>
            <div className='is-pulled-right'>
                <p className='is-size-6'>{item.group}</p>
            </div>
        </div>
    )
}

export default ItemMember
